import { IoIosArrowDroprightCircle } from "react-icons/io";
import { Link } from "react-router-dom";
import {
  MANNING_RESOURCES,
  OUTRO_TEXT_1,
  OUTRO_TEXT_2,
} from "../../constants/translations";
import scrollToTop from "../../hybrids/functions/scrollToTop";
import { RESOURCES_ROUTE } from "../../routes/routes";
const OutroText = () => {
  return (
    <section className="outro-text-section mm-width">
      <p className="outro-texts">{OUTRO_TEXT_1}</p>
      <p className="outro-texts">{OUTRO_TEXT_2}</p>
      <Link
        to={RESOURCES_ROUTE}
        onClick={scrollToTop}
        className="main-btn hero-btn"
      >
        {MANNING_RESOURCES}
        <IoIosArrowDroprightCircle />
      </Link>
    </section>
  );
};

export default OutroText;
